"use strict";

require(['dcf-gallery', 'plugins/body-scroll-lock'], function (DCFGalleryImageModule, bodyScrollLock) {
  // Get all the gallery images and create the theme
  var galleryImages = document.querySelectorAll('.dcf-gallery-img');
  var galleryImageTheme = new DCFGalleryImageModule.DCFGalleryImageTheme();

  // Initialize the gallery images with the theme
  var galleryImageObj = new DCFGalleryImageModule.DCFGalleryImage(galleryImages, galleryImageTheme, bodyScrollLock);
  galleryImageObj.initialize();

  //TODO Add logic here for adding for when you add more images (galleryImageObj.addNewGalleryImage())
});

define("gallery", function(){});

